export const BACKEND_BASE_PATH_PROD = 'https://t3.finsi.com.ph/atlast-time-tracker-api/public/api';
export const BACKEND_BASE_PATH_TEST = 'https://t3uatfinsi.hcx.com.ph/atlas-time-tracker-api/public/api';
export const BACKEND_BASE_PATH_DEV = 'https://devserver2.gq/t3/time-tracker-api/public/api';
//export const BACKEND_BASE_PATH_LOCAL = 'http://localhost/atlas-time-tracker-api/public/api/';
export const BACKEND_BASE_PATH_LOCAL = 'https://t3.finsi.com.ph/atlas-time-tracker-api/public/api';
export const BACKEND_ENV = 'local';

